import _extends from "@babel/runtime-corejs3/helpers/extends";import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import clsx from 'clsx';
import { Home, Help } from "../../icons";
import { colors } from "../../utils";
import Tooltip from "../Tooltip";






import { AlignmentTypes } from "../../types/Tooltip";
import { eeRights, imCelticsRights } from "../../utils/accessRights";
import MobileNavDropdown from "./MobileNavDropdown";
import UserAccountDropdown from "./UserAccountDropdown";
import ToolsDropdown from "./ToolsDropdown";
import { createStyles } from "./styles";
import DevToolsDropdown from "./DevToolsDropdown";
import BaToolsDropdown from "./BaToolsDropdown";

var HeaderLinksRoutes = _Object$freeze({
  HOME: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/dashboard"),
  EMPLOYEE_PROFILE: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/employee"),
  HELP: "https://insurancemenu.zendesk.com/hc/en-us",
  CHANGE_AGENCY: "https://".concat(process.env.REACT_APP_AUTH_FE_BASE_URL, "/change-agency"),
  ACCOUNT_SETTINGS: "https://".concat(process.env.REACT_APP_AUTH_FE_BASE_URL, "/account-settings"),
  USER_SERVICE: "https://".concat(process.env.REACT_APP_USERS_V2_BASE_URL, "/dashboard"),
  LOGOUT: "https://".concat(process.env.REACT_APP_AUTH_FE_BASE_URL, "/logout"),
  BOOK_OF_BUSINESS: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/book-of-business"),
  INSIGHTS: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/insights"),
  UPLOAD_PRODUCTS: 'https://import.demo.insurance-menu.com',
  BI_DASHBOARD: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/bi-dashboard"),
  FAVORITE_PROPOSALS: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/favorite-proposals"),
  OUTPUT_ISSUE_TRACKER: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/output-issue-tracker"),
  UPLOAD_SYNC_FILES: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/upload-sync-files"),
  TRIGGER_RENEWALS: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/trigger-renewals"),
  BE_ERROR_TRACKER: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/be-error-tracker"),
  FILE_EXCHANGE: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/file-exchange-dashboard"),
  PDF_VERIFIER: "https://".concat(process.env.REACT_APP_BROKER_PORTAL_BASE_URL, "/pdf-verifier")
});

var HeaderNavLinks = _Object$freeze([
{
  value: HeaderLinksRoutes.HOME,
  label: 'Home',
  icon: /*#__PURE__*/React.createElement(Home, { width: "2.4rem", height: "2.4rem" })
}]);


export var HeaderSponsorContentMap = _Object$freeze({
  default: {
    logoUrl: 'https://static.insurancemenu.com/im/logo/InsuranceMenuLogo.svg',
    customMainColor: null
  },
  DeltaDental: {
    logoUrl: 'https://static.insurancemenu.com/carrier/DeltaDental/delta-dental-logo.svg',
    customMainColor: colors.special.DeltaDental
  },
  DeltaDentalVision: {
    logoUrl: 'https://static.insurancemenu.com/carrier/ddwi/DeltaDental_DeltaVision.png',
    customMainColor: colors.special.DeltaDental
  },
  AltusDental: {
    logoUrl: 'https://static.insurancemenu.com/carrier/altus/Altus_Logo-H-RGB.svg',
    customMainColor: colors.special.AltusDental
  },
  Unum: {
    logoUrl:
    'https://brokerportalfe-websitebucket-unstable-815698450531.s3.amazonaws.com/Unum_Group_logo.svg',
    customMainColor: colors.special.Unum
  },
  SupportUkraine: {
    logoUrl:
    'https://brokerportalfe-websitebucket-unstable-815698450531.s3.amazonaws.com/InsuranceMenuLogo-1.svg',
    customMainColor: null
  }
});

var HeaderCommon = function HeaderCommon(props) {var _context;
  // Common data
  var
    userAccountInfo =




    props.userAccountInfo,_props$currentSponsor = props.currentSponsorId,currentSponsorId = _props$currentSponsor === void 0 ? 'default' : _props$currentSponsor,currentUserRoles = props.currentUserRoles,_props$sandbox = props.sandbox,sandbox = _props$sandbox === void 0 ? false : _props$sandbox,_props$showTools = props.showTools,showTools = _props$showTools === void 0 ? true : _props$showTools;
  var CurrentSponsorContent =
  HeaderSponsorContentMap[currentSponsorId] || HeaderSponsorContentMap.default;

  var createHomeLink = function createHomeLink() {
    if (eeRights(currentUserRoles)) {
      return HeaderLinksRoutes.EMPLOYEE_PROFILE;
    }

    return HeaderLinksRoutes.HOME;
  };

  // Concomitant layout
  var classes = createStyles({
    customMainColor: CurrentSponsorContent.customMainColor,
    showDevTools: imCelticsRights(currentUserRoles) && showTools
  });

  return /*#__PURE__*/(
    React.createElement("header", { className: classes.header }, /*#__PURE__*/
    React.createElement("div", { className: classes.mobileHeaderWrapper }, /*#__PURE__*/
    React.createElement("a", { href: createHomeLink(), className: classes.mobileHomeLink }, /*#__PURE__*/
    React.createElement(Home, { width: "3.2rem", height: "3.2rem" })), /*#__PURE__*/

    React.createElement(Tooltip, { label: props.userAccountInfo.sponsorName, alignment: AlignmentTypes.BOTTOM_CENTER }, /*#__PURE__*/
    React.createElement("div", { className: classes.mobileScreenLogoWrapper }, /*#__PURE__*/
    React.createElement("img", {
      src: CurrentSponsorContent.logoUrl,
      alt: "".concat(currentSponsorId || 'InsuranceMenu', " logo"),
      className: classes.mobileScreenLogo }))), /*#__PURE__*/



    React.createElement(MobileNavDropdown, _extends({},
    userAccountInfo, {
      currentUserRoles: currentUserRoles,
      customMainColor: CurrentSponsorContent.customMainColor,
      showTools: showTools }))), /*#__PURE__*/


    React.createElement("div", { className: classes.desktopHeaderWrapper }, /*#__PURE__*/
    React.createElement("section", { className: classes.baseSection }, /*#__PURE__*/
    React.createElement("div", { className: classes.headerLogoWrapper }, /*#__PURE__*/
    React.createElement(Tooltip, {
      label: props.userAccountInfo.sponsorName,
      alignment: AlignmentTypes.BOTTOM_CENTER }, /*#__PURE__*/

    React.createElement("img", {
      src: CurrentSponsorContent.logoUrl,
      alt: "".concat(currentSponsorId || 'InsuranceMenu', " logo"),
      className: classes.desktopScreenLogo }))), /*#__PURE__*/



    React.createElement("nav", { className: classes.navigation }, /*#__PURE__*/
    React.createElement("ul", { className: classes.pagesLinksBlock, role: "menu" },
    _mapInstanceProperty(_context = _Object$values(HeaderNavLinks)).call(_context, function (linkObj) {var _context2;
      return /*#__PURE__*/(
        React.createElement("li", {
          role: "menuitem",
          key: _concatInstanceProperty(_context2 = "nav_link_label-".concat(linkObj.label, "_nav_link_value-")).call(_context2, linkObj.value) }, /*#__PURE__*/

        React.createElement("a", {
          href: linkObj.label === 'Home' ? createHomeLink() : linkObj.value,
          className: clsx(classes.link, classes.pageLink) },

        linkObj.icon, /*#__PURE__*/
        React.createElement("span", { className: classes.pageLinkText }, linkObj.label))));



    }),
    showTools && !eeRights(currentUserRoles) && /*#__PURE__*/
    React.createElement("li", { role: "menuitem" }, /*#__PURE__*/
    React.createElement(ToolsDropdown, {
      customMainColor: CurrentSponsorContent.customMainColor,
      currentUserRoles: currentUserRoles })),



    showTools && imCelticsRights(currentUserRoles) && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("li", { role: "menuitem" }, /*#__PURE__*/
    React.createElement(DevToolsDropdown, { customMainColor: CurrentSponsorContent.customMainColor })), /*#__PURE__*/

    React.createElement("li", { role: "menuitem" }, /*#__PURE__*/
    React.createElement(BaToolsDropdown, { customMainColor: CurrentSponsorContent.customMainColor })))), /*#__PURE__*/




    React.createElement("ul", { className: classes.additionalLinksBlock, role: "menu" }, /*#__PURE__*/
    React.createElement(Tooltip, { label: "Help" }, /*#__PURE__*/
    React.createElement("a", { href: HeaderLinksRoutes.HELP, className: classes.link }, /*#__PURE__*/
    React.createElement("li", { className: classes.additionalLinksItem, role: "menuitem" }, /*#__PURE__*/
    React.createElement(Help, { width: "2.4rem", height: "2.4rem" }))))))), /*#__PURE__*/






    React.createElement("section", { className: classes.userAccountSection }, /*#__PURE__*/
    React.createElement(UserAccountDropdown, _extends({},
    userAccountInfo, {
      customMainColor: CurrentSponsorContent.customMainColor,
      currentUserRoles: currentUserRoles,
      sandbox: sandbox,
      showTools: showTools }))))));





};

export default HeaderCommon;
export { HeaderLinksRoutes };
//# sourceMappingURL=index.js.map